export const ATTRIBUTE_NAMES_CONST = {
    applicationType: 'DCJ',
    channel: 'channel',
    source: 'source',
    quote: 'quote',
    customer: 'customer',
    addFund: 'addFund',
    cedingProvider: 'cedingProvider',
    customerNeed: 'customerNeed',
    amountType: 'amountType',
    fundingType: 'Funding Type',
    transferType: 'Transfer Type',
    dob: 'dateOfBirth',
    ukAddressInd: 'ukaddressIndicator',
    pensionFund: 'pensionFund',
    cedingPension: 'cedingPension',
    productOptions: 'productOptions',
    playground: 'playground',
    quotePlayback: 'quotePlayback',
    productType: 'Product Type',
    channelSource: 'channelSource',
    productCode: 'productCode',
    referenceDate: 'referenceDate',
    success: 'Success',
    registered: 'Registered',
    login: 'Login',
    failure: 'Failure',
    unavailable: 'Unavailable',
    continue_to_quote: 'Continue to quote',
    back_to_landing: 'Close and go back',
    quoteJourneyType: 'QuoteJourneyType',
    origoInd: 'On Origo Options System Ind'
}